export const LIST_DEFAULT_CLASSNAME =
  "flex flex-wrap items-center gap-1.5 text-sm text-muted-foreground";
export const ITEM_DEFAULT_CLASSNAME = "inline-flex items-center gap-1.5";
export const LINK_DEFAULT_CLASSNAME = "transition-colors hover:text-foreground";
export const PAGE_DEFAULT_CLASSNAME = "font-medium text-foreground";
export const SEPARATOR_DEFAULT_CLASSNAME = "text-muted-foreground";
export const ELLIPSIS_DEFAULT_CLASSNAME =
  "flex h-9 w-9 items-center justify-center";
export const ELLIPSIS_ICON_CLASSNAME = "h-4 w-4";
